var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-video"},[_c('el-dialog',{attrs:{"title":"预览","visible":_vm.isShow},on:{"update:visible":function($event){_vm.isShow=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }